<template>
    <div>
        <div class="ui inverted dimmer transition" :class="{'active': is_loading}">
            <div class="ui text loader">
                <!-- 處理中... -->
                {{ $t('ui.general.initializing') }}
            </div>
        </div>

        <div class="clear"></div>
        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="partition in partitions"
                    :key="partition.identity"
                    :object="partition"
                    :title="partition.name"
                    :title_link="{name: 'edit_provider_partition', params: {partition_identity: partition.identity}}"
                    :is_show_column="true"
                    :i_18n_key="'partitions'"
                    :keys="['numbers_from','numbers_to','total_amount','available_quantity','parent','customer','contracts','material','note']"
                >
                    <span slot="total_amount">
                        {{ $store.getters[store_key+'number_with_commas'](partition.numbers_amount) }}
                    </span>
                    <span slot="available_quantity">
                        {{ $store.getters[store_key+'number_with_commas'](partition.remaining_numbers) }}
                    </span>
                    <span slot="parent">
                        <div class="ui items" v-if="partition.child_partitions && partition.child_partitions.length">
                            <router-link class="item" v-for="(child_partition, index) in partition.child_partitions"
                                :key="child_partition.identity"
                                :to="{
                                    name: 'edit_partition',
                                    params: {
                                        partition_identity: child_partition.identity
                                    }
                                }">
                                {{ index + 1 }}. {{ child_partition.name }}
                            </router-link>
                        </div>
                        <span v-else>-</span>
                    </span>
                    <span slot="contracts">
                        <div class="ui items" v-if="$store.getters[store_key+'current_customer'](partition)">
                            <router-link class="item" v-for="(contract, index) in partition.contracts"
                                :key="contract.identity"
                                :to="{
                                    name: 'provider_contract',
                                    params: {
                                        customer_identity: $store.getters[store_key+'current_customer'].identity,
                                        contract_identity: contract.identity
                                    }
                                }">
                                {{ index + 1 }}. {{ contract.name }}
                            </router-link>
                        </div>
                        <span v-else>-</span>
                    </span>
                    <span slot="customer">
                        <router-link v-if="$store.getters[store_key+'current_customer'](partition)" :to="{name: 'customer', params: {customer_identity: $store.getters[store_key+'current_customer'](partition).identity}}">
                            {{ $store.getters[store_key+'current_customer'](partition).company_short_name || $store.getters[store_key+'current_customer'](partition).identity }}
                        </router-link>
                        <span v-else>
                            <!--
                                automatic_number 自動取號,
                                use_yourself 自用
                            -->
                            {{
                                partition.partition_type == "Auto"
                                    ? $t('ui.pages.partitions.automatic_number')
                                    : $t('ui.pages.partitions.use_yourself')
                            }}
                        </span>
                    </span>
                    <router-link
                        slot="material"
                        v-if="$store.getters[store_key+'current_material'](partition)" :to="{name: 'edit_material', params: {material_identity: $store.getters[store_key+'current_material'](partition).identity}}">
                        {{ $store.getters[store_key+'current_material'](partition).name }}
                    </router-link>

                    <div slot="buttons">
                        <div v-if="!partition.is_deleting" @click.prevent="delete_partition(partition)" class="ui basic red button">
                            {{ $t('ui.general.delete') }}
                        </div>
                        <div v-else class="ui basic red button">
                            {{ $t('ui.general.deleteing') }}...
                        </div>
                    </div>
                </DataCard>

                <div v-if="!is_loading && partitions.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui celled table">
                <thead>
                    <tr>
                        <th>{{ $t('models.attributes.partitions.name') }}</th>
                        <th>{{ $t('models.attributes.partitions.numbers') }}</th>
                        <th>{{ $t('models.attributes.partitions.parent') }}</th>
                        <th>{{ $t('models.attributes.partitions.customer') }}</th>
                        <th>{{ $t('models.attributes.partitions.contracts') }}</th>
                        <th>{{ $t('models.attributes.partitions.material') }}</th>
                        <th>{{ $t('models.attributes.partitions.note') }}</th>
                        <th class="center aligned">{{ $t('ui.general.operate') }}</th>
                    </tr>
                </thead>
                <tbody v-if="is_initialized">
                    <Row v-for="partition in partitions"
                        :key="partition.identity"
                        :partition="partition">
                    </Row>
                </tbody>
            </table>

            <Paginator
                :total_pages="Number(current_store.pagination.total_pages)"
                :current_page="Number(current_store.pagination.current_page)">
            </Paginator>
        </div>
    </div>
</template>

<script>
import Row from "./row.vue"
import DataCard from '@toolbox/data_card/main.vue'
import Paginator from '@toolbox/pagination/paginator.vue'
export default {
    name: "PartitionsIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            is_deleting: false,
            store_key: 'provider/partitions_module/'
        }
    },
    computed: {
        style: (instance) => instance.$store.state.style,
        current_store: (instance) => instance.$store.state.provider.partitions_module,
        partitions() {
            return this.current_store.partitions
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    beforeDestroy() {
        this.current_store.pagination.current_page = 1
    },
    watch: {
        '$route': {
            async handler(to, from) {
                var page = to.query.page
                if (page) {
                    this.current_store.pagination.current_page = Number(page)
                    await new Promise(resolve => {
                        this.is_loading = true
                        resolve()
                    })
                    await this.$store.dispatch('provider/partitions_module/fetch_partitions', {
                        page: page
                    })
                    await new Promise(resolve => {
                        this.is_loading = false
                        resolve()
                    })
                }
            },
            deep: true,
        },
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.current_store.pagination.current_page = (this.$route.query.page)
                    ? this.$route.query.page
                    : 1
                this.is_initialized = false
                resolve()
            })
            await this.$store.dispatch('provider/partitions_module/fetch_partitions', {
                page: this.current_store.pagination.current_page
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        delete_partition(partition) {
            console.log('delete_partition');
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                partition.is_deleting = true

                let url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_partition_delete).parse(
                    {
                        partition_identity: partition.identity
                    }
                );

                axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            // this.$noty.success("刪除號碼區間成功");
                            this.$noty.success(
                                this.$t('ui.notifications.success.delete__name', {
                                    name: this.$t('models.partitions')
                                })
                            );
                            this.$store.commit('provider/partitions_module/remove_partition', partition)
                            this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "partitions")
                        } else {
                            // this.$noty.error("刪除號碼區間失敗")
                            this.$noty.error(
                                this.$t('ui.notifications.error.delete__name', {
                                    name: this.$t('models.partitions')
                                })
                            )
                        }
                        partition.is_deleting = false
                    })
                    .catch(error => {
                        // this.$noty.error("刪除號碼區間失敗")
                        partition.is_deleting = false
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.partitions')
                            })
                        )
                    })
                    .finally(() => {
                        this.$forceUpdate()
                    })
            }
        },
    },
    components: {
        Row,
        Paginator,
        DataCard,
    }
}
</script>

<style lang="scss">
</style>
